// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//   apiUrl: 'http://localhost:4022/api/v1/',
  apiUrl: 'https://eapply-demo-api.ysoft.gr/api/v1/',
  productSchoolId: 1,
  baseUrl: 'https://eapply-demo.ysoft.gr',
  version: '1.0.0'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
